import React from 'react';
import CreateUserView from '../../views/user/create';
import { UserCollection } from '../../services/collection';
import { withRouter } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';

class CreateUserScreen extends React.Component {

  state = {
    editing: null
  };

  onSave = async () => {
    if (!this.isValid()) {
      return null;
    }
    const { editing } = this.state;
    // Ignore passwordRepeated
    const { password, passwordRepeated: unused, ...user } = editing;
    await new Promise(resolve => this.setState({
      disabled: true
    }, resolve));
    try {
      await UserCollection.actions.create(
        {
          ...user,
          active: true
        },
        password
      );
      const { history } = this.props;
      // If we can go back, do it, if we can't then go home
      if (history.length >= 1) {
        history.go(-1);
      } else {
        history.push('/');
      }
    } catch(e) {
      console.warn(e);
      alert('Failed to create user');
      await new Promise(resolve => this.setState({
        disabled: false
      }, resolve));
    }
  };

  onCancel = () => {
    const { history } = this.props;
    if (history.length >= 1) {
      history.go(-1);
    } else {
      history.push('/');
    }
  };

  isValid() {
    const { editing } = this.state;
    if (!editing) {
      return false;
    }
    const { userName, firstName, lastName, password, passwordRepeated } = editing;
    return !!(
      userName &&
      isEmail(userName) &&
      firstName &&
      lastName &&
      password &&
      passwordRepeated &&
      password.length >= 8 &&
      passwordRepeated.length >= 8 &&
      password === passwordRepeated
    );
  }

  onChange = (property) => {
    return value => this.setState(({ editing }) => ({
      editing: {
        ...(editing || {}),
        [property]: value
      }
    }));
  };

  render() {
    const { onChange, onSave, onCancel } = this;
    const { editing, disabled } = this.state;
    const {
      userName,
      firstName,
      lastName,
      password,
      passwordRepeated,
    } = (editing || {});
    return (
      <div style={{ padding: 15 }}>
        <CreateUserView
          userName={userName || ''}
          firstName={firstName || ''}
          lastName={lastName || ''}
          password={password || ''}
          passwordRepeated={passwordRepeated || ''}
          onUserName={onChange('userName')}
          onFirstName={onChange('firstName')}
          onLastName={onChange('lastName')}
          onPassword={onChange('password')}
          onPasswordRepeated={onChange('passwordRepeated')}
          disabled={disabled}
          onSave={onSave}
          onCancel={onCancel}
          canSave={this.isValid()}
        />
      </div>
    )
  }
}

export default withRouter(CreateUserScreen);


// WEBPACK FOOTER //
// ./src/app/user/create.js